import React from 'react';
import { useTranslate } from 'react-redux-multilingual'
import { Loading } from '@gull';
import TicketFacture from "../../../app/views/Pdf/TicketFacture"
import TicketFactureSupplement from "../../../app/views/Pdf/TicketFactureSupplement"
import useLoadPublicTicket from './useLoadPublicTicket';
import { exposeServerRenderError } from './serverRender';
import PublicDocumentNotFound from './PublicDocumentNotFound';
import PublicPdfPreview from './PublicPdfPreview';
import {computePublicTicketTotals} from './publicTicketTotals';

/**
 * Page publique de consultation de la facture d'un ticket B2C (sans authentification), affiche son PDF.
 */
const PublicVisualTicketFacture = ({company,id,token}) => {
    const t = useTranslate();
    const [loading,ticketDetail,section,companyInfos,moduleInfos,pointsFidelite,error404] = useLoadPublicTicket(company, id, token)

    if(loading){
        return(
            <Loading></Loading>
        )
    }

    if(error404 || Object.keys(ticketDetail).length==0){
        exposeServerRenderError('ticketNotFound')
        return(<PublicDocumentNotFound />)
    }

    const {totalAchat,tgcForTicketPdf,tgcTotal} = computePublicTicketTotals(ticketDetail.ticket_detail, companyInfos)

    const supplement_list_params = moduleInfos.params?.article?.params?.supplement_list
    const TicketFactureComponent = supplement_list_params ? TicketFactureSupplement : TicketFacture

    return(
        <PublicPdfPreview
            title="Aperçu de la facture"
            document={
                <TicketFactureComponent
                    t={t}
                    documentType='billing'
                    companyInfos={{...section, other_company: section.other_company || []}}
                    authParam={{company:companyInfos}}
                    ticketFacture={ticketDetail}
                    totalTgc={tgcTotal}
                    totalAchat={totalAchat}
                    tgcForTicketPdf={tgcForTicketPdf}
                    devise={companyInfos.devise}
                    pointsFidelite={pointsFidelite}
                    moduleParam={moduleInfos}
                />
            }
        />
    )
}

export default PublicVisualTicketFacture;
